export const staticTextLookup = {}